module.exports = __webpack_public_path__ + "media/images/meeting/ic_calendar-c9afe3187e14320106929191aa14f945.svg";